<!--
equipment model chooser
AT
13.03.23
-->

<svelte:window
	on:dataUpdated={setData}
/>

<script>
	//import { beforeUpdate, afterUpdate } from 'svelte'
	//import SvgSprite from '../_shared/components/svg-sprite.svelte'

	let
		equipments = [],
		offers = [],
		extraoffers = [],
		selectedOfferUID,
		price = 0,
		currency = {}

	function setData(e){
//console.log('e.detail: ', e.detail)
		equipments = e.detail.user.equipments
		offers = e.detail.offers
		currency = e.detail.currency
	}

	async function selectOffer(){
		//unfortunately there's no easy way to bind (Object)selectedOfferUID to this function, using (String)selectedOfferUID
		let
			selectedOffer = offers.filter( obj => { return obj.uid == selectedOfferUID } )[0]

		price = selectedOffer.price

		//getting extraoffers
		fetch( '/api/offer/extraoffers?offer=' + selectedOfferUID )
		.then(function(response) { return response.json() })
		.then(function(response) {
//console.log('response: ',response)
			extraoffers = response
//console.log('extraoffers: ',extraoffers)
		})
	}

	function toggleExtraoffer(e){
		//unfortunately there's no easy way to bind (Object)selectedExtraofferUID to this function, using (String)selectedExtraofferUID
//console.log('e.target.checked: ',e.target.checked)
		let
			selectedExtraofferUID = e.target.value,
			selectedExtraoffer = extraoffers.filter( obj => { return obj.uid == selectedExtraofferUID } )[0]

		price = e.target.checked? price + selectedExtraoffer.price : price - selectedExtraoffer.price
	}

</script>

<form
	data-validator="/api/validator/order/add"
	data-action="/api/order/add/"
	data-method="post"
	data-event="orderAdded"
	class="uk-card uk-card-default uk-card-body uk-flex uk-flex-middle uk-flex-between flex-gap"
>
	<div>
		<div class="uk-flex uk-flex-middle uk-flex-between flex-gap">
			<label class="flex-1">
				Моё снаряжение
				<select name="equipment" class="uk-input uk-select">
					{ #each equipments as equipment }
						<option value="{ equipment.uid }">
							{ equipment.manufacturer }
							{ equipment.model }
							{ equipment.size }
						</option>
					{ /each }
				</select>
			</label>
			<label class="flex-1">
				Услуга
				<select name="offer" class="uk-input uk-select" bind:value={ selectedOfferUID } on:change={ selectOffer }>
					<option></option>
					{ #each offers as offer }
						<option value="{ offer.uid }">
							{ offer.title }
							({ offer.price } { window.data.currency.symbol })
						</option>
					{ /each }
				</select>
			</label>
			<label class="flex-2">
				Заметки и пожелания
				<input type="text" name="summary" placeholder="порвал две стропы" class="uk-input">
			</label>
		</div>
		{ #if extraoffers.length>0 }
			<div class="uk-padding-small">
				<label>
					Дополнительные услуги
				</label>
				<div class="uk-flex uk-flex-middle flex-gap">
					{ #each extraoffers as extraoffer }
						<label>
							<input type="checkbox" name="extraoffers[]" value="{ extraoffer.uid }" data-validate="no" on:change={ toggleExtraoffer } />
							{ extraoffer.title } <span class="comment">+ { extraoffer.price } { window.data.currency.symbol }</span>
						</label>
					{ /each }
				</div>
			</div>
		{ /if }
	</div>

	<div class="uk-flex uk-flex-middle uk-flex-between flex-gap">
		<br>
		<button class="uk-button uk-button-primary">
			заказать
			{ #if price }
				<br>
				за { price } { currency.symbol }
			{ /if }
		</button>
	</div>

</form>